import { render, staticRenderFns } from "./MspAllenamentoDetail.vue?vue&type=template&id=c3adb954"
import script from "./MspAllenamentoDetail.vue?vue&type=script&lang=js"
export * from "./MspAllenamentoDetail.vue?vue&type=script&lang=js"
import style0 from "./MspAllenamentoDetail.vue?vue&type=style&index=0&id=c3adb954&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports